export default {
  list: {
    loadError: 'Failed to load studies. Please retry.',
  },
  notFound: {
    shareRevoked: 'The owner stopped sharing this link.',
    title: 'Study not found',
    goToStudies: 'Go to studies',
    noAccess: "This study doesn't exist or you don't have access to it.",
    couldNotLoad: 'This study could not be loaded.',
  },
  pageError: {
    title: 'Something went wrong on this page',
    body: 'Your study is still there. Reload the page to try again, and let us know if it keeps happening.',
  },
  staleBundle: {
    title: 'New version available',
    body: 'This tab has been open since the last deploy and is trying to load assets that have moved. Reload the page to pick up the new build — your study is still there.',
    reload: 'Reload',
  },
  results: {
    notReadyTitle: 'Results not ready',
    notReadyMessage:
      'Results unlock when a simulation completes or stops with saved diagnostics.',
    simulationsRunning:
      'Some simulations are still running. Return to Simulate to follow their progress.',
    backToSimulate: 'View Simulate',
  },
  diagnose: {
    preprocessingMessage: 'Diagnostics are now part of the Mesh step.',
    movedTitle: 'Diagnose moved into Mesh',
    draftMessage:
      'Use the Mesh step to configure mesh settings before running the study.',
    sharedMessage: 'Diagnostics and meshing now share the Mesh step.',
  },
  status: {
    unknownTitle: 'Unknown status',
    unknownMessage: 'Study is in an unrecognized state ({{state}}).',
  },
  simulate: {
    notYetTitle: 'Not simulating yet',
    notYetMessage: 'Simulate starts once the Mesh step is complete.',
    completeTitle: 'Simulations complete',
    completeMessage: 'This study has moved past the Simulate step.',
  },
} as const;
